<template>
  <div>
    <v-card>
      <v-card-text>
        <InputTextDatePicker ref="dateCommande" v-model="dateCommande" label="Date de la commande" :isRequired="true" />

        <v-text-field v-model="montantCommande" label="Montant € HT de la commande" type="number"
          :error-messages="montantCommandeErrors" @input="$v.montantCommande.$touch()"
          @blur="$v.montantCommande.$touch()" required></v-text-field>
        <v-text-field v-model="numeroCommande" label="Numéro de la commande" :error-messages="numeroCommandeErrors"
          @input="$v.numeroCommande.$touch()" @blur="$v.numeroCommande.$touch()" required></v-text-field>
        <DragAndDropInputFile ref="mainFile" v-model="fichierCommande" label="Fichier Commande"
          :rules="rulesFichierCommande" :multiple="false" :isRequired="true" />


        <InputFilesAdditional @on-file-added="fichierComplementaire=$event" />

        <span class="fichier d-flex justify-start ml-2">
          Le poid maximal autorisé par fichier est de 32 Mo
        </span>

        <div class="d-flex justify-end mt-5">
          <v-btn class="mr-3" @click="previous">précédent</v-btn>
          <v-btn color="primary" @click="submit">Envoyer</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import InputTextDatePicker from "@/components/Inputs/InputTextDatePicker.vue";
import DragAndDropInputFile from "@/components/Inputs/DragAndDropInputFile.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import InputFilesAdditional from "../Inputs/InputFilesAdditional.vue";

export default {
  name: "DepotCommandeCommande",
  components: { InputTextDatePicker, DragAndDropInputFile, InputFilesAdditional },
  data() {
    return {
      dateCommande: null,
      montantCommande: null,
      numeroCommande: null,
      fichierCommande: [],
      fichierComplementaire: [],

      rulesFichierCommande: [
        (value) =>
          (value && !value.length) ||
          (value &&
            value.reduce((size, file) => size + file.size, 0) < 32000000) ||
          "La taille maximum d'un fichier est de 32 Mo",
        (value) =>
          (value && value.length) <= 1 ||
          "Le maximum de fichier autorisé est de 1",
      ],
    };
  },

  mixins: [validationMixin],

  validations: {
    dateCommande: {
      required,
    },
    montantCommande: {
      required,
    },
    numeroCommande: {
      required,
    },
    fichierCommande: {
      required,
    },
  },

  methods: {
    submit() {
      const stepData = {
        dateCommande: this.dateCommande,
        montantCommande: this.montantCommande,
        numeroCommande: this.numeroCommande,
        fichierCommande: this.fichierCommande,
        fichierComplementaire: this.fichierComplementaire,
      };
      this.touch();
      if (this.isValid) {
        this.$emit("onSubmit", stepData);
      }
    },
    touch() {
      this.$v.$touch();
      this.$refs.mainFile.isValid();
      this.$refs.dateCommande.$v.$touch();
    },
    previous() {
      this.$emit("onPrevious");
    },
  },

  computed: {
    isValid() {
      return (
        !this.$v.$invalid &&
        !this.$refs.dateCommande.$v.$invalid &&
        this.$refs.mainFile.isValid()
      );
    },

    dateCommandeErrors() {
      const errors = [];
      if (!this.$v.dateCommande.$dirty) return errors;
      !this.$v.dateCommande.required &&
        errors.push("La date du devis est requise.");
      return errors;
    },
    montantCommandeErrors() {
      const errors = [];
      if (!this.$v.montantCommande.$dirty) return errors;
      !this.$v.montantCommande.required &&
        errors.push("Le montant du devis est requis.");
      return errors;
    },
    numeroCommandeErrors() {
      const errors = [];
      if (!this.$v.numeroCommande.$dirty) return errors;
      !this.$v.numeroCommande.required &&
        errors.push("Le numéro du devis est requis.");
      return errors;
    },
    fichierCommandeErrors() {
      const errors = [];
      if (!this.$v.fichierCommande.$dirty) return errors;
      !this.$v.fichierCommande.required &&
        errors.push("Le fichier devis est requis.");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.fichier {
  font-size: 12px;
}
</style>